import React from 'react';
import heroImg from './assets/hero-img.png';
import arrowImage from './assets/arror-img.png';
import './style/hero.css';

const HeroSection = () => {
  return (
    <div id="homeSection" className="bg-[#ffffff] font-sans mt-[0rem] md:mt-[3rem]">
      <div className="container mx-auto min-h-screen flex items-center justify-center pt-24 md:pt-8 p-8 overflow-hidden">
        <div className="grid md:grid-cols-2 items-center gap-y-16 md:gap-0 relative w-full max-w-6xl">


          <div className="flex flex-col gap-4 text-center md:text-left">
            <h1 className="text-2xl md:text-4xl lg:text-5xl font-bold text-gray-800 responsive-line-height">
              A Mobile App That{' '}
              <span className="relative">
                Helps
                <svg
                  className="absolute -bottom-2 left-0 w-[150%] md:w-[150%]"
                  viewBox="0 0 400 20"
                  preserveAspectRatio="none"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2 12.3272C50.2451 1.30234 259.18 -9.10088 398 12.3272"
                    stroke="#87CEEB"
                    strokeWidth="4"
                    strokeLinecap="round"
                  />
                </svg>
              </span>
              <br />
              Agents Look Like Top
              <br />
              Agents.
            </h1>

            <p
              className="text-xl md:text-xl text-gray-500"
              style={{ fontFamily: 'Inter, "Helvetica Neue", Helvetica, Arial, sans-serif' }}
            >
              Built for agents in the field. No laptop? No
              <br />
              problem!
            </p>


          </div>

          <div className="flex justify-center md:justify-end">


            <img
              src={heroImg}
              alt="A professional agent using a mobile app"
              className="w-full h-auto max-w-md"
            />

          </div>

          <img
            src={arrowImage}
            alt="decorative arrow"
            className="absolute w-20 bottom-10 left-[55%] hidden md:block"
          />

        </div>
      </div>
    </div>
  );
};

export default HeroSection;